import { render, staticRenderFns } from "./HandoverProtocol.yaml?vue&type=template&id=56c7f192&component"
import script from "./HandoverProtocol.yaml?vue&type=script&lang=ts&component"
export * from "./HandoverProtocol.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports